/**
 * Shared constants used across the application
 */

export const ERROR_CODE_FORBIDDEN = 'FORBIDDEN_STUDENT_ACCESS';
